module.exports = __webpack_public_path__ + "img/FikirCoin.d7163edf.png";